import { Button } from './button';

/**
 * Empty state (DESIGN → Motion, T-1311): a big emoji that pops in, one short line and at most
 * one button. `compact` for a section inside a screen.
 */
export function EmptyState({
	emoji,
	text,
	action,
	compact = false,
}: {
	emoji: string;
	text: string;
	action?: { label: string; onClick: () => void } | undefined;
	compact?: boolean;
}) {
	return (
		<div
			className={`flex flex-col items-center gap-3 text-center ${compact ? 'py-4' : 'px-6 py-12'}`}
		>
			<span
				aria-hidden="true"
				className={`animate-pop leading-none ${compact ? 'text-[40px]' : 'text-[56px]'}`}
			>
				{emoji}
			</span>
			<p className="text-body text-text-muted">{text}</p>
			{action !== undefined && (
				<Button variant="secondary" onClick={action.onClick}>
					{action.label}
				</Button>
			)}
		</div>
	);
}
